import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  padding: 22px 41px 0px 41px;
  max-width: 100vw;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 31px;
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 700px) {
    flex-direction: column;
  }
  & > div {
    margin-bottom: 22px;
  }
`;

export default {
  Container,
  InformationContainer,
};
